import { Controller } from "@hotwired/stimulus"

// Drives the guided new-ticket form (Phase C). Picking a category reveals that
// category's field group and hides the rest; a hidden group's inputs must not be
// `required`, or the browser blocks submit on fields the student can't see, so we
// toggle `required` off/on with the group's visibility (the required intent is
// declared per input via data-guided-required).
//
// It also reveals a free-text course field when the student's course isn't in
// their package list (pre-purchase / wrong-section cases).
export default class extends Controller {
  static targets = ["group", "packageSelect", "courseOther"]

  connect() {
    this.showActiveGroup()
    this.togglePackageOther()
  }

  categoryChanged() {
    this.showActiveGroup()
  }

  get selectedSlug() {
    const checked = this.element.querySelector('input[name="category"]:checked')
    return checked ? checked.value : null
  }

  showActiveGroup() {
    const slug = this.selectedSlug
    this.groupTargets.forEach((group) => {
      const active = group.dataset.slug === slug
      group.classList.toggle("d-none", !active)
      group.querySelectorAll("input, select, textarea").forEach((field) => {
        field.required = active && field.dataset.guidedRequired === "true"
      })
    })
  }

  togglePackageOther() {
    if (!this.hasPackageSelectTarget || !this.hasCourseOtherTarget) return
    const other = this.packageSelectTarget.value === "__other__"
    this.courseOtherTarget.classList.toggle("d-none", !other)
  }
}
